import React from 'react';
import ReactTooltip from 'react-tooltip';
import './styles.css';

interface Props {
    status: boolean;
    /** Sucesso, mas ainda na fila (não enviado) — mostra amarelo em vez de verde. */
    queued?: boolean;
    unit: string;
    mail: string;
    message: string;
}

const Status: React.FC<Props> = ({ status, queued = false, unit, mail, message }) => {
    /** Fila/enfileirado não é falha: amarelo se `queued`, vermelho só se falha real (e não enfileirado). */
    const isError = !status && !queued;
    const isQueued = Boolean(queued);
    const tooltipType = isError ? 'error' : isQueued ? 'warning' : 'success';

    return (
        <>
            <div className='status_line'>
                <span
                    className={`status ${isError ? 'err' : isQueued ? 'queued' : ''}`}
                    data-for="tooltip_box_status"
                    data-tip={message}
                    data-type={tooltipType}
                ></span>
                <span className='unit'>{unit}</span>
                <span className='mail'>{mail}</span>
            </div>

            <ReactTooltip
                id="tooltip_box_status"
                place="right"
                effect="solid"
            />
        </>
    )
}

export default Status;